'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Caret } from '@sprd/sprd-component-kit/v2';
import { ReactNode, useCallback, useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { useClickOutside } from '@/hooks/useClickOutside';
import { DROPDOWN_BOTTOM_MARGIN, DROPDOWN_MAX_HEIGHT_MULTI_ROW, DROPDOWN_MAX_HEIGHT_SINGLE_ROW, DROPDOWN_MIN_HEIGHT, useIsWrapped } from '@/components/Filters/FilterListContext';
type FilterDropdownProps = {
  hideFooter?: boolean;
  filterLabel: ReactNode;
  resetDisabled?: boolean;
  selectedCount?: number;
  dropdownContent: ReactNode;
  showProductsDisabled?: boolean;
  dropdownContentClassName?: string;
  onReset?: () => void;
  onShowProducts?: () => void;
};
export const FilterDropdown = t0 => {
  const $ = _c(42);
  const {
    hideFooter: t1,
    filterLabel,
    selectedCount,
    resetDisabled: t2,
    dropdownContent,
    showProductsDisabled: t3,
    dropdownContentClassName,
    onReset,
    onShowProducts
  } = t0;
  const hideFooter = t1 === undefined ? false : t1;
  const resetDisabled = t2 === undefined ? false : t2;
  const showProductsDisabled = t3 === undefined ? false : t3;
  const [open, setOpen] = useState(false);
  const [dropdownMaxHeight, setDropdownMaxHeight] = useState(DROPDOWN_MAX_HEIGHT_SINGLE_ROW);
  const [alignment, setAlignment] = useState("left");
  const ref = useRef(null);
  const isWrapped = useIsWrapped();
  let t4;
  if ($[0] !== onShowProducts || $[1] !== open || $[2] !== showProductsDisabled) {
    t4 = () => {
      if (open && !showProductsDisabled) {
        onShowProducts?.();
      }
      setOpen(false);
    };
    $[0] = onShowProducts;
    $[1] = open;
    $[2] = showProductsDisabled;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleClickOutside = t4;
  useClickOutside(ref, handleClickOutside);
  const maxHeightLimit = isWrapped ? DROPDOWN_MAX_HEIGHT_MULTI_ROW : DROPDOWN_MAX_HEIGHT_SINGLE_ROW;
  let t5;
  if ($[4] !== maxHeightLimit) {
    t5 = () => {
      const rect = ref.current?.getBoundingClientRect();
      if (!rect) {
        setDropdownMaxHeight(maxHeightLimit);
        setAlignment("left");
        return;
      }
      const availableHeight = window.innerHeight - rect.bottom - DROPDOWN_BOTTOM_MARGIN;
      setDropdownMaxHeight(Math.max(DROPDOWN_MIN_HEIGHT, Math.min(availableHeight, maxHeightLimit)));
      setAlignment(rect.left > window.innerWidth / 5 * 3 ? "right" : "left");
    };
    $[4] = maxHeightLimit;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const calculateDropdownPosition = t5;
  let t6;
  let t7;
  if ($[6] !== calculateDropdownPosition || $[7] !== open) {
    t6 = () => {
      if (!open) {
        return;
      }
      calculateDropdownPosition();
      window.addEventListener("resize", calculateDropdownPosition);
      return () => window.removeEventListener("resize", calculateDropdownPosition);
    };
    t7 = [open, calculateDropdownPosition];
    $[6] = calculateDropdownPosition;
    $[7] = open;
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  useEffect(t6, t7);
  let t8;
  if ($[10] !== open) {
    t8 = () => setOpen(!open);
    $[10] = open;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== selectedCount) {
    t9 = !!selectedCount && <span className="flex h-4 w-4 items-center justify-center bg-black text-[10px] text-white">{selectedCount}</span>;
    $[12] = selectedCount;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== filterLabel || $[15] !== open || $[16] !== t8 || $[17] !== t9) {
    t10 = <FilterDropdownButton open={open} onClick={t8}>{filterLabel}{t9}</FilterDropdownButton>;
    $[14] = filterLabel;
    $[15] = open;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = !open;
  let t12;
  if ($[19] !== dropdownMaxHeight) {
    t12 = {
      maxHeight: dropdownMaxHeight
    };
    $[19] = dropdownMaxHeight;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== alignment || $[22] !== dropdownContentClassName || $[23] !== open) {
    t13 = clsx(open ? ["shadow-dropdown absolute z-20 mt-1 flex w-[327px] flex-col bg-white pt-5 pb-4", dropdownContentClassName] : "hidden", alignment === "left" ? "left-0" : "right-0");
    $[21] = alignment;
    $[22] = dropdownContentClassName;
    $[23] = open;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== dropdownContent) {
    t14 = <div className="min-h-0 flex-1 overflow-y-auto"><div className="px-6 pt-1">{dropdownContent}</div></div>;
    $[25] = dropdownContent;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== hideFooter || $[28] !== onReset || $[29] !== onShowProducts || $[30] !== resetDisabled || $[31] !== showProductsDisabled) {
    t15 = !hideFooter && <FilterDropdownFooter onReset={() => {
      setOpen(false);
      onReset?.();
    }} onShowProducts={() => {
      setOpen(false);
      onShowProducts?.();
    }} resetDisabled={resetDisabled} showProductsDisabled={showProductsDisabled} />;
    $[27] = hideFooter;
    $[28] = onReset;
    $[29] = onShowProducts;
    $[30] = resetDisabled;
    $[31] = showProductsDisabled;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t11 || $[34] !== t12 || $[35] !== t13 || $[36] !== t14 || $[37] !== t15) {
    t16 = <div inert={t11} style={t12} className={t13}>{t14}{t15}</div>;
    $[33] = t11;
    $[34] = t12;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t10 || $[40] !== t16) {
    t17 = <div ref={ref} className="relative">{t10}{t16}</div>;
    $[39] = t10;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  return t17;
};
type FilterDropdownButtonProps = {
  open: boolean;
  children: ReactNode;
  onClick: () => void;
};
const FilterDropdownButton = t0 => {
  const $ = _c(7);
  const {
    open,
    children,
    onClick
  } = t0;
  const t1 = open ? "border-neutral-800 text-neutral-800" : "border-black text-black";
  let t2;
  if ($[0] !== t1) {
    t2 = clsx("group inline-flex size-fit cursor-pointer items-center justify-center gap-1 border-2 bg-white px-3 py-2 text-sm font-semibold", "hover:border-neutral-800 hover:text-neutral-800", "focus-visible:shadow-[0_0_0_2px_var(--white)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus", "aria-disabled:cursor-default aria-disabled:border-neutral-600 aria-disabled:text-neutral-500", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Caret className="scale-200 text-black group-aria-disabled:text-neutral-500" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== onClick || $[5] !== t2) {
    t4 = <button className={t2} onClick={onClick}>{children}{t3}</button>;
    $[3] = children;
    $[4] = onClick;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
type FilterDropdownFooterProps = {
  onReset?: () => void;
  onShowProducts?: () => void;
  resetDisabled?: boolean;
  showProductsDisabled?: boolean;
};
const FilterDropdownFooter = t0 => {
  const $ = _c(17);
  const {
    onReset,
    onShowProducts,
    resetDisabled,
    showProductsDisabled
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <hr className="mt-4 mb-4 h-px w-full bg-neutral-300" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = clsx("flex-1 border-2 border-black bg-white whitespace-nowrap text-black", "hover:border-neutral-800 hover:text-neutral-800", "disabled:cursor-default disabled:border-neutral-600 disabled:text-neutral-500");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t("filter.reset");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onReset || $[5] !== resetDisabled || $[6] !== t3) {
    t4 = <Button variant="plain" className={t2} onClick={onReset} disabled={resetDisabled}>{t3}</Button>;
    $[4] = onReset;
    $[5] = resetDisabled;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("filter.showProducts");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== onShowProducts || $[11] !== showProductsDisabled || $[12] !== t5) {
    t6 = <Button variant="primary" className="flex-1 border-2 border-black whitespace-nowrap" onClick={onShowProducts} disabled={showProductsDisabled}>{t5}</Button>;
    $[10] = onShowProducts;
    $[11] = showProductsDisabled;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t6) {
    t7 = <div className="flex-shrink-0 bg-white">{t1}<div className="flex w-full items-stretch gap-2 px-6">{t4}{t6}</div></div>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};